import styled from "styled-components";
import color from "../../assets/css/colors";

export const ThComponent = styled.th`
    font-family: muli, sans-serif;
    font-weight: 800;
    font-style: normal;
    color: ${color.grayDark};
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
    text-transform: uppercase;
`;